<template>
    <b-container v-if="load.Loading" class="container-basic-spinner">
        <spinner />
    </b-container>
    <div v-else>

        <b-row class="table-nav-row">
            <b-col class="pl-0">
                <custom-multiselect v-model="selectedTag" 
                                    :options="tags"
                                    track-by="Id"
                                    label="Name"
                                    placeholder="Выберите метатег"          
                                    @select="selectParenTag" />
            </b-col>

            <b-col class="pr-0 h-space-between">
                <custom-color-multiselect v-model="selectedSubTag" 
                                          :options="subTags"
                                          track-by="Id"
                                          label="Name"
                                          placeholder="Выберите тег"
                                          class="mr-15"                                      
                                          @select="selectSubTag" />

                <b-button variant="outline-success" 
                        class="search-input-append-button" 
                        @click="clearFilter">
                    Очистить
                </b-button>
            </b-col>            
        </b-row>
        
        <custom-table-list :options="filterActivities"
                           :fields="fields"
                           placeholder-search="Поиск активности"
                           edit-link="/Admin/Activities/Edit"  
                           :apiVersion="apiHeaders['api-Version']"/>
    </div>

</template>
<script>
import Consts from '@/store/models/consts/adminConsts'

import apiService from '@/services/api.service'

import Loading from '@/store/models/Loading'
import Spinner from '@/components/shared/Spinner'
import ApiHeaders from '@/store/models/ApiHeaders'

import CustomTableList from '@/components/shared/CustomTableList'
import CustomMultiselect from '@/components/shared/CustomMultiSelect'
import CustomColorMultiselect from '@/components/shared/CustomColorMultiSelect'

export default {
    computed: {
        subTags: function() {
            return this.selectedTag 
                        ? this.selectedTag.SubTags
                        : [];
        }
    },
    data: function() {
        let load = new Loading();

        let apiHeaders = new ApiHeaders().mapToDto(this.$route.query['api-Version']); 

        this.getActivities(load, apiHeaders);
        this.getParentTags(load, apiHeaders);

        return {
            load: load,
            apiHeaders: apiHeaders,

            tags: [],
            selectedTag: null,
            selectedSubTag: null,

            filterActivities: [],

            entity: null,
            fields: [
                {
                    key: 'OldId',
                    label: 'ID',
                    sortable: true
                },
                {
                    key: 'Name',
                    label: 'Наименование',
                    sortable: true,
                    tdAttr: value => {
                        return { width: "60%" };
                    }
                },
                {
                    key: 'Status',
                    label: 'Статус',
                    sortable: true,
                    formatter: value => {
                        return Consts.ActivityAuditStatus.find(e => e.Id == value).Text;
                    }
                }
            ]
        }
    },    
    methods: {
        getActivities: function(load, apiHeaders) {
            load.Calculate(true);

            apiService.Admin.Activities.GetAll(apiHeaders)
                .then(response => {
                    this.entity = response.data;
                    this.filterActivities = response.data;
                    load.Calculate(false);
                })
                .catch(() => load.Calculate(false));
        },
        getParentTags: function(load, apiHeaders) {
            load.Calculate(true);

            apiService.Admin.Tags.Activities.GetParentTags(apiHeaders)
                .then(response => {
                    this.tags = response.data;
                    load.Calculate(false);
                })
                .catch(() => load.Calculate(false));
        },
        selectParenTag: function(item) {
            if(item)
                this.selectedSubTag = null;

            item
                ? this.filterActivities = this.entity.filter(e => e.MetaTags.some(m => m.Id == item.Id))
                : this.filterActivities = this.entity;
        },
        selectSubTag: function(item) {
            item
                ? this.filterActivities = this.entity.filter(e => e.SubTags.some(s => s.Id == item.Id))
                : this.selectedTag 
                        ? this.filterActivities = this.entity.filter(e => e.MetaTags.some(m => m.Id == this.selectedTag.Id))
                        : this.filterActivities = this.entity;
        },
        clearFilter: function() {
            this.selectedTag = null;
            this.selectedSubTag = null;
            this.filterActivities = this.entity;
        }
    },
    components: {
        Spinner,
        CustomTableList,
        CustomMultiselect,
        CustomColorMultiselect
    }
}
</script>